// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"990136d7","637":"444f9fb8","696":"faf770c7","788":"d435ac12"}[chunkId] + ".chunk.js";
};